import lazyLoadOnRender from '../../lazy/loadOnRender';

const VivaEngageAppNotifications = () =>
  import(/* webpackChunkName: "4-feat-vivaengageappnotifications" */ './VivaEngageAppNotifications');
export default lazyLoadOnRender({ loader: VivaEngageAppNotifications });
